const METERS_SQUARED = 'm²';
const METERS = 'm';

// Conversion constants kept for migrating legacy feet data to meters
const SQUARE_FEET_TO_METERS = 1 / 10.764;
const FEET_TO_METERS = 1 / 3.281;

const formatCurrency = (value, locale = 'en-GB', currency = 'GBP') => {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value);
};

/**
 * Migrate legacy room data from feet to meters
 * @param {Array} rooms - Array of room objects
 * @returns {Array} - Rooms with ft2 converted to m2
 */
const migrateRoomsToMeters = (rooms) => {
    if (!Array.isArray(rooms)) return rooms;

    let migrated = false;
    const migratedRooms = rooms.map(room => {
        if (room.unitType === 'ft2') {
            migrated = true;
            return {
                ...room,
                projectSize: Number((room.projectSize * SQUARE_FEET_TO_METERS).toFixed(2)),
                width: room.width ? Number((room.width * FEET_TO_METERS).toFixed(2)) : room.width,
                length: room.length ? Number((room.length * FEET_TO_METERS).toFixed(2)) : room.length,
                unitType: 'm2'
            };
        }
        return room;
    });

    return { rooms: migratedRooms, migrated };
};

module.exports = {
    METERS_SQUARED,
    METERS,
    SQUARE_FEET_TO_METERS,
    FEET_TO_METERS,
    formatCurrency,
    migrateRoomsToMeters
}